import { NgModule } from '@angular/core';

import { FeatureToggleModule } from 'ish-core/feature-toggle.module';
import { LAZY_FEATURE_MODULE } from 'ish-core/utils/module-loader/module-loader.service';

import { LazySalesRepUsersListComponent } from './lazy-sales-rep-users-list/lazy-sales-rep-users-list.component';

@NgModule({
  imports: [FeatureToggleModule],
  providers: [
    {
      provide: LAZY_FEATURE_MODULE,
      useValue: {
        feature: 'salesRep',
        location: () => import('../store/sales-rep-store.module').then(m => m.SalesRepStoreModule),
      },
      multi: true,
    },
  ],
  declarations: [LazySalesRepUsersListComponent],
  exports: [LazySalesRepUsersListComponent],
})
export class SalesRepExportsModule {}
